<template>
      <div class="grid p-fluid">

            <div class="col-12 md:col-12">
                  <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
            </div>
            <div class="col-12 md:col-12">
                  <div class="card">

                        <div class="col-12 md:col-12">
                              <div class="grid formgrid">
                                    <div class="col-12 md:col-2">
                                          <span class="p-input-icon-left">
                                                <InputText type="text" placeholder="Search By Number" />
                                                <i class="pi pi-search" />
                                          </span>
                                    </div>
                                    <div class="col-12 md:col-8">
                                          <SelectButton v-model="selectButtonValue1" :options="selectButtonValues1"
                                                optionLabel="name" />
                                    </div>
                                    <div class="col-12 md:col-2">
                                          <Button type="button" class="mr-2 mb-2" label="Refresh" icon="pi pi-refresh"
                                                @click="refresh" />
                                    </div>
                              </div>
                        </div>
                        <div class="col-12 md:col-12">
                              <Splitter style="height: 500px" class="mb-5">
                                    <SplitterPanel :size="30" :minSize="10" style="overflow: scroll">
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                              <div class="card" style="box-shadow: 0px 10px 10px rgba(0,0,0,0.15);"><div class="col-12 md:col-12"><hr><p>MH24AU4684</p></div></div>
                                          
                                    </SplitterPanel>
                                    <SplitterPanel :size="30" :minSize="10"
                                          class="flex align-items-center justify-content-center"> Panel 2 </SplitterPanel>
                                    <SplitterPanel :size="50" :minSize="10"
                                          class="flex align-items-center justify-content-center"> Panel 3 </SplitterPanel>
                              </Splitter>


                        </div>


                  </div>
            </div>


      </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import BreadcrumbService from "../service/BreadcrumbService";
import apis from "@/apis";
export default {
      name: 'SbmUiGps',

      data() {
            return {
                  productService: null,
                  BreadcrumbService: null,
                  filters: {},
                  breadcrumbHome: {},
                  breadcrumbItems: [],
                  selectButtonValue1: null,
                  selectButtonValues1: [
                        { name: 'All', code: 'O1' },
                        { name: 'Stopped', code: 'O2' },
                        { name: 'Moving', code: 'O3' },
                        { name: 'Low Network', code: 'O4' },
                        { name: 'Disconnected', code: 'O5' },
                  ],
            };
      },

      mounted() {

      },
      created() {
            this.productService = new ProductService();
            this.initFilters();
            this.BreadcrumbService = new BreadcrumbService();
            let Breadcrum_data = this.BreadcrumbService.getBreadcrum(
                  "GPS Report",
                  "/gps"
            );
            this.breadcrumbHome = Breadcrum_data.home;
            this.breadcrumbItems = Breadcrum_data.items;
      },

      methods: {
            initFilters() {
                  this.filters = {
                        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                  };
            },

      },
};
</script>

<style lang="scss" scoped></style>